import {
  DESELECT_JOB_INDUSTRY_FILTER,
  DESELECT_JOB_TYPE_FILTER,
  FETCH_JOBS,
  FETCH_NEXT_JOBS,
  FETCH_RECENT_JOBS,
  FETCH_SIMILAR_FEATURED_JOBS,
  FETCH_SIMILAR_SPONSORED_JOBS,
  FETCH_SPONSORED_JOBS,
  JOBS_FILTER_INITIAL_STATE,
  RESET_JOB_FILTERS,
  RESET_SEARCH,
  SELECT_FLOAT_BUTTON,
  SELECT_JOB_INDUSTRY_FILTER,
  SELECT_JOB_TYPE_FILTER,
  SELECT_RADIUS_FILTER,
  SET_HR_MODE,
  SET_KEYWORD_SEARCH_FILTER,
  SET_SALARY_FILTER,
  SET_SHOW_RECENT_JOBS,
} from "./jobsConstants";
import { SIGN_OUT_USER } from "../auth/authConstants";
import {
  BACKWARDS_SEARCH,
  FORWARDS_SEARCH,
  INITIAL_SEARCH,
} from "../../app/firestore/firestoreService";
import { HR_ALL_MODE } from "../modes/constants";

const JOBS_INITIAL_STATE = {
  mode: HR_ALL_MODE,
  filters: JOBS_FILTER_INITIAL_STATE,
  isShowRecentJobs: true,
  availableJobs: [],
  sponsoredJobs: [],
  recentJobs: [],
  similarFeaturedJobs: [],
  similarSponsoredJobs: [],
  isMoreJobs: false,
  firstVisible: null,
  lastVisible: null,
  queryCode: null,
  page: 1,
};

function getSearchPage(page, searchDirection) {
  if (searchDirection === INITIAL_SEARCH) {
    return page;
  } else if (searchDirection === FORWARDS_SEARCH) {
    return page + 1;
  } else if (searchDirection === BACKWARDS_SEARCH) {
    return page - 1;
  }
}

export default function jobsReducer(
  state = JOBS_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case FETCH_JOBS:
      return {
        ...state,
        availableJobs: payload.jobs || [],
        isMoreJobs: payload.isMoreJobs,
        firstVisible: payload.firstVisible || null,
        lastVisible: payload.lastVisible || null,
        queryCode: payload.queryCode || null,
        page: getSearchPage(state.page, payload.searchDirection) || 1,
      };
    case FETCH_NEXT_JOBS:
      return {
        ...state,
        availableJobs: payload.jobs || [],
        isMoreJobs: payload.isMoreJobs,
        firstVisible: payload.firstVisible || null,
        lastVisible: payload.lastVisible || null,
        queryCode: payload.queryCode || null,
        page: getSearchPage(state.page, payload.searchDirection) || 1,
      };
    case FETCH_SPONSORED_JOBS:
      return {
        ...state,
        sponsoredJobs: payload,
      };
    case FETCH_RECENT_JOBS:
      return {
        ...state,
        recentJobs: payload,
      };
    case FETCH_SIMILAR_FEATURED_JOBS:
      return {
        ...state,
        similarFeaturedJobs: payload,
      };
    case FETCH_SIMILAR_SPONSORED_JOBS:
      return {
        ...state,
        similarSponsoredJobs: payload,
      };
    case SELECT_JOB_TYPE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          type: [payload],
        },
      };
    case DESELECT_JOB_TYPE_FILTER:
      return {
        ...state,
        // filters: removeTypeFilter(state),
        filters: {
          ...state.filters,
          type: [],
        },
      };
    case SELECT_JOB_INDUSTRY_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          industry: [payload],
        },
      };
    case DESELECT_JOB_INDUSTRY_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          industry: [],
        },
      };
    case SELECT_RADIUS_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          radius: payload,
        },
      };
    case SET_KEYWORD_SEARCH_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          keyword: payload,
        },
      };
    case SET_SALARY_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          salary: payload,
        },
      };
    case RESET_JOB_FILTERS:
      return {
        ...state,
        filters: { ...JOBS_FILTER_INITIAL_STATE },
      };
    case RESET_SEARCH:
      return {
        ...state,
        availableJobs: [],
        isMoreJobs: false,
        firstVisible: null,
        lastVisible: null,
        queryCode: null,
        page: 1,
      };
    case SELECT_FLOAT_BUTTON:
      return {
        ...state,
        filters: {
          ...state.filters,
          selectedFloatButton: payload,
        },
      };
    case SET_SHOW_RECENT_JOBS:
      return {
        ...state,
        isShowRecentJobs: payload,
      };
    case SET_HR_MODE: {
      return {
        ...state,
        mode: payload,
      };
    }
    case SIGN_OUT_USER:
      return {
        ...state,
        filters: { ...JOBS_FILTER_INITIAL_STATE },
      };
    default:
      return state;
  }
}
